(function() {
    'use strict';

    angular
        .module('pcsApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
